export async function fetchJsonFromApiOrThrow<T>(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<T> {
  const resp = await fetch(input, init);

  const text = await resp.text();
  const json = text ? (JSON.parse(text) as unknown) : null;

  if (!resp.ok) {
    const errBody = (json ?? {}) as { error?: string; code?: string };
    const message =
      errBody.error ?? `Request failed (${resp.status} ${resp.statusText})`;

    const e = new Error(message) as Error & { code?: string; status?: number };
    e.code = errBody.code;
    e.status = resp.status;
    throw e;
  }

  return json as T;
}
